import { Abstrap } from '..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class Title extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-title',
            className,
        ];
    }

}

Title.propTypes = propTypes;

Title.defaultProps = defaultProps;

export default Title;
